import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenu", "mobileButton", "menuIcon", "closeIcon"]
  static values = { scrolledClass: String }

  connect() {
    this.isScrolled = false
    this.isMobileOpen = false
    this.handleScroll = this.handleScroll.bind(this)
    this.handleResize = this.handleResize.bind(this)

    window.addEventListener("scroll", this.handleScroll, { passive: true })
    window.addEventListener("resize", this.handleResize, { passive: true })

    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("resize", this.handleResize)
  }

  handleScroll() {
    const scrolled = window.scrollY > 20
    if (scrolled === this.isScrolled) return

    this.isScrolled = scrolled
    if (this.scrolledClassValue) {
      this.scrolledClassValue.split(" ").forEach(cls => this.element.classList.toggle(cls, scrolled))
    }
  }

  handleResize() {
    if (window.innerWidth >= 1024 && this.isMobileOpen) {
      this.closeMobile()
    }
  }

  toggleMobile() {
    if (this.isMobileOpen) {
      this.closeMobile()
    } else {
      this.openMobile()
    }
  }

  openMobile() {
    this.isMobileOpen = true
    this.mobileMenuTarget.classList.remove("opacity-0", "-translate-y-2", "pointer-events-none")
    this.mobileMenuTarget.classList.add("opacity-100", "translate-y-0", "pointer-events-auto")
    this.mobileMenuTarget.setAttribute("aria-hidden", "false")
    this.mobileButtonTarget.setAttribute("aria-expanded", "true")
    this.menuIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
  }

  closeMobile() {
    this.isMobileOpen = false
    this.mobileMenuTarget.classList.add("opacity-0", "-translate-y-2", "pointer-events-none")
    this.mobileMenuTarget.classList.remove("opacity-100", "translate-y-0", "pointer-events-auto")
    this.mobileMenuTarget.setAttribute("aria-hidden", "true")
    this.mobileButtonTarget.setAttribute("aria-expanded", "false")
    this.menuIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
  }
}
